<template>
  <div>
    <b-navbar toggleable="sm" type="light" variant="light">
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item to="/monitor" :active="this.$route.path == '/monitor'"><car-icon /> Monitor</b-nav-item>
          <b-nav-item to="/connect" :active="this.$route.path == '/connect'"><bullhorn-icon /> Connect </b-nav-item>
          <b-nav-item disabled><clock-icon /> Analytics</b-nav-item>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item-dropdown right>
            <template slot="button-content"><em>User</em></template>
            <!-- <b-dropdown-item href="#">Profile</b-dropdown-item> -->
            <b-dropdown-item href="#">Sign Out</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>


<script>
export default {
  name: 'NavBar',
}
</script>


<style scoped>

.navbar {
  padding: 0 1rem;
  font-size: 0.9rem;
}

.nav-link {
  padding-top: 0;
  padding-bottom: 0;
}

</style>
